import Trophy from '@rover/icons/svg/trophy.svg';
import useTheme from '@rover/kibble/themes/useTheme';

type Props = {
  size?: number;
};

/** The trophy glyph shared by the inline and featured experience highlights. */
const ExperienceTrophyIcon = ({ size = 24 }: Props): JSX.Element => {
  const theme = useTheme();
  return <Trophy width={size} height={size} fill={theme.textColor.primary} aria-hidden="true" />;
};

export default ExperienceTrophyIcon;
